import React, { useState, useEffect } from "react";
import "./index.less";
import { Button, Form, message, } from 'antd';
import { request, setUser } from "@/utils";
import { Func, rsaEncrypt } from "@/utils/func";
import IconPswon from '@/assets/icon-psw-on.png'
import IconPswoff from '@/assets/icon-psw-off.png'
import { useNavigate } from "react-router-dom";
export default function ResetPwd() {
    const [countdown, setCountdown] = useState(60); // 初始倒计时值
    const [isCounting, setIsCounting] = useState(false); // 标志是否在倒计时中
    const [form] = Form.useForm(); // 创建表单实例
    const [showPwd, setShowPwd] = useState(true)
    const [params, setParams] = useState({ mobile: null, code: null, password: null })
    const [info, setInfo] = useState({})
    const navigate = useNavigate();
    const onFinish = async () => {
        console.log('999999')
        if (!params.code) {
            message.error('请输入手机验证码')
            return false
        }
        if (!params.password) {
            message.error('请输入密码')
            return false
        }
        if (!/^(?=.*[0-9])(?=.*[a-zA-Z]).{8,}$/.test(params.password)) {
            message.error('密码需包含字母和数字，长度为8-16位')
            return false
        }
        let pwd = await rsaEncrypt(params.password);
        const response = await request.post('auth/reset-pwd-web', {
            mobile: info.mobile,
            password: pwd,
            code: params.code,
        });
        if (response.code) {
            message.success(response.msg)
        } else {
            message.success('密码修改成功')
            navigate(-1)
        }
    };
    const startCountdown = () => {
        setIsCounting(true);
        const interval = setInterval(() => {
            setCountdown((prevCount) => {
                if (prevCount <= 1) {
                    clearInterval(interval);
                    setIsCounting(false);
                    setCountdown(60)
                }
                return prevCount - 1;
            });
        }, 1000);
    };

    const handleSendCode = () => {
        try {
            const phoneNumber = info.mobile;
            console.log(phoneNumber);
            // 手机号码验证，你可以根据实际需求修改验证规则
            const response = request.post('auth/mobile-code', {
                mobile: phoneNumber,
                type: 2
            });
            // 这里使用 setTimeout 模拟异步操作
            message.success('验证码已发送');
            startCountdown();
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    };
    const fetchData = async (page, perPage) => {
        try {
            const response = await request.get('auth/info'); // 使用封装好的Axios实例发送GET请求
            if (response.code) {
                message.error(response.msg)
            } else {
                setInfo(response.data)
                setUser(response.data)
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };
    useEffect(() => {
        fetchData();
    }, [])
    return (
        <div className="updatePassword">
            <div className="updatePassword-container">
                <div className="back" onClick={() => navigate(-1)}>返回 </div>
                <div className="updatePassword-form">
                    <div className="title">修改密码</div>
                    <div className='label'>手机号码</div>
                    <div className="phone-input mg20" style={{ background: 'rgba(0, 0, 0, 0.03)' }}>
                        <input placeholder="请输入手机号码" size="large" value={info.mobile} disabled />
                    </div>
                    <div className='label'>手机验证码</div>
                    <div className='sendCode'>
                        <div className="phone-input">
                            <input placeholder="请输入手机验证码" size="large" value={params.code} onInput={(e) => {
                                params.code = e.target.value
                                setParams({ ...params })
                            }} />
                        </div>
                        <Button
                            className='sender-code'
                            type="primary"
                            size="large"
                            onClick={handleSendCode}
                            disabled={isCounting}
                            style={{ backgroundColor: isCounting ? '#f9f5ef' : '', color: isCounting ? '#C59D60' : '' }}
                        > {isCounting ? `${countdown}S后重发` : '发送验证码'}</Button>
                    </div>
                    <div className='label'>密码</div>
                    <div className="phone-input mg20">
                        <input placeholder="请输入密码" size="large" type={showPwd ? 'text' : "password"} value={params.password} onInput={(e) => {
                            params.password = e.target.value
                            setParams({ ...params })
                        }} ></input>
                        {
                            showPwd ? <img className="pwd-icon" src={IconPswon} alt="" onClick={() => { setShowPwd(false) }} /> :
                                <img className="pwd-icon" src={IconPswoff} alt="" onClick={() => { setShowPwd(true) }} />
                        }
                    </div>
                    <div className='modify-pwd-hint'>
                        新密码需包含字母和数字，长度为8-16位
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Button
                            style={{
                                width: "120px",
                                height: "40px",
                                marginRight: "31px",
                                marginBottom: "25px",
                                fontSize: "14px",
                                borderRadius: "4px",
                            }}
                            onClick={() => { navigate(-1) }}>取消</Button>
                        <Button
                            type="primary" htmlType="submit"
                            style={{
                                width: "120px",
                                height: "40px",
                                marginBottom: "25px",
                                fontSize: "14px",
                                borderRadius: "4px",
                            }} onClick={onFinish}>确定</Button>
                    </div>

                </div>
            </div>

        </div>
    );

}

